export const analyzeAPI = {
  UPLOAD: 'csv/2.0.0/post_file',
  DASHBOARD: `lambdaro/momentum/customer-${process.env.REACT_APP_API_ENV}-dashboard`,
  ANALYZE: `lambdaro/momentum/customer-${process.env.REACT_APP_API_ENV}-analyze`,
};
